import React, { useEffect, useState, useRef } from 'react'
import { Row, Col, Button, Card, Space, Modal, Slider, ConfigProvider, Input } from 'antd'
import { Image as MobileImage, ImageViewer as MobileImageViewer } from 'antd-mobile'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import AntdTable from '@/components/table/AntdTable'
import { formatMessageNew } from '@/utils/common'
import { messageModal, modalError } from '@/utils/modalUtils'
import { scanResult, scanRecord, scanRecordDetail } from '@/services/rfid/greyMarket/greyMarket'
import {
  onKeyMsg,
  onReadTagResult,
  // onReadListTagResult,
  setKeyCall,
  startRFID,
  stopRFID,
  setReadSetting,
  onReadSetting,
  getReadSetting,
  onScanBarcodeResult
} from '@/services/rfEpc'
import dayjs from 'dayjs'
import './scan.less'
import Global_Combined from '@/assets/images/qrCode/Global_Combined.png'
import Local_QR_Code from '@/assets/images/qrCode/Local_QR_Code.png'
let imageInfo1 = {
  img: Global_Combined
  // w: 320,
  // h: 76
}
let imageInfo2 = {
  img: Local_QR_Code,
  w: 76,
  h: 76
}

const { TextArea } = Input
const formatDt = 'YYYY-MM-DD HH:mm:ss'
const GreyMarketScanRF = () => {
  const marks = {
    1: 1,
    33: 33
  }

  const [marksObj, setMarksObj] = useState(marks)
  const [slideValue, setSlideValue] = useState(1)
  const [status, setStatus] = useState('idle')
  const [visibleFlag, setVisibleFlag] = useState(false)
  const [activeRow, setActiveRow] = useState(null)
  const [scanTableList, setScanTableList] = useState([])
  const [checkItem, setCheckItem] = useState([])
  const [tableList, setTableList] = useState([])
  const [scanType, setScanType] = useState(1) // 1: EPC, 2: QR
  const [gcInputValue, setGCInputValue] = useState('')
  const [nikeInputValue, setNikeInputValue] = useState('')
  const [epc, setEpc] = useState('')

  let scanValueList = useRef([])

  useEffect(() => {
    initApiFun()
    getScanRecord()
    onReadTagResult(_data => {
      let resValue = ''
      let resList = []
      if (_data && _data.data) {
        resList = _data.data.map(item => {
          return item.tagValue
        })
        resValue = resList.join(',')
      }
      let newArr = [...scanValueList.current, ...resList]
      // 去重
      scanValueList.current = Array.from(new Set(newArr))
      setEpc(resValue)
    })
    // onReadListTagResult(_data => {
    //   let resValue = ''
    //   if (_data && _data.data) {
    //     let resList = _data.data.map(item => {
    //       return item.tagValue
    //     })
    //     resValue = resList.join(',')
    //   }
    //   scanValueList.current = resValue
    // })
    onKeyMsg(isStart => {
      if (isStart) {
        // // 扳机开始时初始化，清空数据
        // setKeyCall(1, true)
        scanValueList.current = []
        setEpc('')
        setStatus('reading')
      } else {
        const epcValue = scanValueList.current.join(',')
        setStatus('idle')
        setEpc(epcValue)
        getEpcScanResult(epcValue)
      }
    })
    onScanBarcodeResult(data => {
      checkQrCode(data)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const checkQrCode = value => {
    let valueUpperCase = value.toUpperCase()
    if (valueUpperCase.indexOf('HTTPS') !== -1) {
      setNikeInputValue(valueUpperCase)
    } else {
      setGCInputValue(valueUpperCase)
    }
  }
  const initApiFun = async () => {
    setKeyCall(1, true)
    getReadSetting()
    onReadSetting(settings => {
      let val = (settings && settings.power) || 1
      setSlideValue(val)
      setMarksObj({ ...marks, [val]: val })
    })
  }
  const startBtnClick = async () => {
    try {
      setEpc('')
      scanValueList.current = []
      await startRFID(true)
      setStatus('reading')
    } catch (error) {
      console.error('ERR src/page/RfidReading.vue 01:', error)
    }
  }
  const stopBtnClick = async () => {
    try {
      await stopRFID()
      setStatus('idle')
      getEpcScanResult(epc)
    } catch (error) {
      console.error('ERR src/page/RfidReading.vue 02', error)
    }
  }
  const getEpcScanResult = epcValue => {
    let epcs = []
    if (epcValue) {
      epcs = epcValue.trim().split(',')
    } else {
      return
    }
    const params = {
      type: scanType,
      epcs: epcs
    }
    requestScanResult(params)
  }
  const requestScanResult = params => {
    scanResult(params)
      .then(res => {
        setScanTableList(res.resultData || [])
        getScanRecord()
        if (scanType !== 1) {
          setScanType(1)
          setKeyCall(1, true)
          setStatus('idle')
          setGCInputValue('')
          setNikeInputValue('')
        }
      })
      .catch(err => {
        setKeyCall(0)
        setScanTableList([])
        if (err.errorCode === '1500') {
          modalError({ content: formatMessageNew('languageObj.greyMarketLocale.error1500') })
        } else if (err.errorCode === '5003') {
          modalError({ content: getErrorMessageHtml(err) })
        } else if (['4001', '436', '437'].includes(err.errorCode)) {
          let content = ''
          switch (err.errorCode) {
            case '4001':
              content = formatMessageNew('languageObj.defectiveReturnLocale.invalidQRCodeFormat')
              break
            case '436':
              content = formatMessageNew('languageObj.defectiveReturnLocale.noAssociatedEPC')
              break
            case '437':
              content = formatMessageNew('languageObj.defectiveReturnLocale.illegalQRCode')
              break
            default:
              break
          }
          modalError({ content }, () => {
            setGCInputValue('')
            setNikeInputValue('')
            setKeyCall(2)
          })
        } else {
          modalError({ content: formatMessageNew('languageObj.httpLocale.requestError') })
        }
      })
  }
  const getErrorMessageHtml = (err = {}) => {
    let str = formatMessageNew('languageObj.greyMarketLocale.errorcode_' + err.errorCode)
    let resLs = []
    if (err.errorCode === '5003') {
      resLs.push(imageInfo2)
      resLs.push(imageInfo1)
    }
    let domStr = (
      <div>
        {str || err.errorMessage}
        <div className="displayFlex alignCenter justifyContentCenter flexDirectionC">
          {resLs.map((item, index) => {
            return (
              <div key={index} className="mt10">
                <MobileImage
                  src={item.img}
                  width={item.w}
                  height={item.h}
                  onClick={() => {
                    MobileImageViewer.Multi.show({ images: resLs.map(item => item.img), defaultIndex: index })
                  }}
                />
              </div>
            )
          })}
        </div>
      </div>
    )
    return domStr
  }
  const getScanRecord = () => {
    scanRecord().then(res => {
      const dt = res.resultData
      setTableList(dt)
    })
  }
  const setPowerOnClick = async e => {
    try {
      await setReadSetting(e)
      messageModal('success', {
        content: formatMessageNew('languageObj.commonLocale.success')
      })
    } catch (error) {
      messageModal('error', {
        content: formatMessageNew('languageObj.commonLocale.error') + error
      })
    }
  }
  const tableColumns = [
    {
      title: '#',
      dataIndex: 'index',
      align: 'center',
      width: 50,
      render: (text, record, index) => index + 1
    },
    {
      title: formatMessageNew(`languageObj.greyMarketLocale.scanResult`),
      render: record => {
        const { upc, style, size, epc, gmScanTime } = record
        return (
          <Space direction="vertical" size="10" style={{ display: 'flex' }}>
            <strong className="h20 displayFlex alignCenter">
              {upc}&nbsp;&nbsp;{style}
              {style ? '/' : ''}
              {size}
            </strong>
            <div className="h20 displayFlex alignCenter">{epc}</div>
            <div className="h20 displayFlex alignCenter">{gmScanTime && dayjs(gmScanTime).format(formatDt)}</div>
          </Space>
        )
      }
    }
  ]

  const resultFields = [
    { key: 'upc', span: 8, valueKey: 'upc' },
    { key: 'style', span: 8, valueKey: 'sku' },
    { key: 'size', span: 8, valueKey: 'size' },
    { key: 'markFor', span: 8, valueKey: 'markFor' },
    { key: 'soldTo', span: 16, valueKey: 'soldTo' },
    { key: 'shipTo', span: 8, valueKey: 'shipTo' },
    { key: 'obScanTime', span: 16, valueKey: 'obScanTime' }
  ]

  const setSliderValueFun = e => {
    setSlideValue(e)
    setMarksObj({ ...marks, [e]: e })
  }
  const onAfterChange = e => {
    setPowerOnClick(e)
  }

  const handleUserCancel = () => {
    setVisibleFlag(false)
    setActiveRow(null)
  }
  const clickTableRow = (record, idx) => {
    setActiveRow(idx)
    getRecordDetail(record)
  }
  const getRecordDetail = record => {
    let params = {
      epc: record.epc || '',
      localQrCode: record.localQrCode || ''
    }
    scanRecordDetail(params).then(res => {
      const dt = res.resultData
      setVisibleFlag(true)
      setCheckItem([dt])
    })
  }
  const rowClassNameFun = (record, idx) => {
    if (activeRow === idx) {
      return 'active_class_name'
    }
  }
  const scanResultHtml = (ls, showTitle) => {
    return ls.map((item, itemIdx) => {
      return (
        <Space key={itemIdx} className="mt15" direction="vertical" size="middle" style={{ display: 'flex' }}>
          <Card title={showTitle && formatMessageNew(`languageObj.greyMarketLocale.scanResult`)} size="small">
            <Row>
              {resultFields.map(({ key, span, valueKey }, idx) => (
                <Col
                  span={span}
                  key={key}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    marginBottom: `${idx < resultFields.length - 2 ? 10 : 0}px`
                  }}
                >
                  <span>{formatMessageNew(`languageObj.greyMarketLocale.${key}`)}</span>
                  <strong className="h20 word_break_all pr5" style={{ lineHeight: 1.1 }}>
                    {valueKey === 'obScanTime'
                      ? item && item.shipToType === 1 && item[valueKey] && dayjs(item[valueKey]).format(formatDt)
                      : item[valueKey]}
                  </strong>
                </Col>
              ))}
            </Row>
          </Card>
        </Space>
      )
    })
  }

  const onEpcChange = e => {
    setEpc(e.target.value)
    if (e && e.target && e.target.value && e.target.value.length > 0) {
      setStatus('reading')
    }
  }
  const handleScanTypeChange = type => {
    if (status === 'reading') setStatus('idle')
    setScanType(type)
    if (type === 1) {
      // 切换到EPC
      setKeyCall(1, true)
      if (gcInputValue) setGCInputValue('')
      if (nikeInputValue) setNikeInputValue('')
    } else {
      // 切换到QR
      setKeyCall(2)
      if (epc) setEpc('')
    }
  }
  const onQrCodeSearch = () => {
    const params = {
      type: scanType,
      localQrCode: gcInputValue,
      qrCode: nikeInputValue
    }
    requestScanResult(params)
  }

  return (
    <div>
      <Card size="small">
        <div className="grey-market-scan-wrapper">
          <div style={{ flex: 1 }}>
            {scanType === 1 ? (
              <Row type="flex" gutter={[0, 8]}>
                <Col span={16}>
                  <Input
                    size="large"
                    value={epc}
                    placeholder={formatMessageNew('languageObj.greyMarketLocale.scanPlaceholder')}
                    onChange={onEpcChange}
                  />
                </Col>
                <Col
                  xs={8}
                  sm={8}
                  md={8}
                  lg={8}
                  xl={8}
                  xxl={8}
                  className="right_search"
                  style={{ display: 'flex', justifyContent: 'flex-end' }}
                >
                  {status === 'idle' && (
                    <Button
                      type="primary"
                      size="large"
                      onClick={() => {
                        startBtnClick()
                      }}
                      icon={<SearchOutlined />}
                    >
                      {formatMessageNew(`languageObj.greyMarketLocale.scan`)}
                    </Button>
                  )}
                  {status === 'reading' && (
                    <Button
                      icon={<RedoOutlined className="btn_loading" />}
                      size="large"
                      onClick={() => {
                        stopBtnClick()
                      }}
                    >
                      {formatMessageNew(`languageObj.greyMarketLocale.stopScan`)}
                    </Button>
                  )}
                </Col>
              </Row>
            ) : (
              <Row type="flex" gutter={[0, 8]}>
                <Col span={16}>
                  <div className="fontS11 text-tips-line-height color-ff5000">
                    {formatMessageNew('languageObj.greyMarketLocale.scanTips1')}
                  </div>
                </Col>
                <Col span={8}></Col>
                <Col span={16}>
                  <TextArea
                    autoSize
                    size="large"
                    value={gcInputValue}
                    placeholder={formatMessageNew('languageObj.greyMarketLocale.qrCodeTips1')}
                    onChange={e => {
                      setGCInputValue(e.target.value)
                    }}
                    className="mb5"
                  />
                  <div className="fontS11 text-tips-line-height color-ff5000 pb5">
                    {gcInputValue && gcInputValue.length >= 11
                      ? formatMessageNew('languageObj.greyMarketLocale.scanTips2')
                      : ''}
                  </div>
                  <TextArea
                    autoSize
                    size="large"
                    value={nikeInputValue}
                    placeholder={formatMessageNew('languageObj.greyMarketLocale.qrCodeTips2')}
                    onChange={e => {
                      setNikeInputValue(e.target.value)
                    }}
                  />
                </Col>
                <Col span={8} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Button
                    size="large"
                    type="primary"
                    icon={<SearchOutlined />}
                    style={{ marginLeft: 10 }}
                    onClick={onQrCodeSearch}
                  >
                    查询
                  </Button>
                </Col>
              </Row>
            )}
          </div>
          <Row>
            <Col span={24} style={{ textAlign: 'center', marginTop: 10 }}>
              <div
                className={`switch-btn ${scanType === 1 ? 'switch-btn-qrCode' : 'switch-btn-epc'}`}
                size="large"
                onClick={() => handleScanTypeChange(scanType === 1 ? 2 : 1)}
              >
                {`${formatMessageNew('languageObj.greyMarketLocale.switchTo')}
                ${scanType === 1 ? 'QR Code' : 'RFID EPC'}`}
              </div>
            </Col>
          </Row>
        </div>
      </Card>
      <Card className="mt15" size="small">
        <div className="displayFlex alignCenter">
          <div className="mr10">{formatMessageNew(`languageObj.greyMarketLocale.devicePower`)}:</div>
          <div style={{ flex: 1 }}>
            <ConfigProvider
              theme={{
                components: {
                  Slider: {
                    railSize: 6
                  }
                }
              }}
            >
              <Slider
                min={1}
                max={33}
                value={slideValue}
                marks={marksObj}
                onChange={setSliderValueFun}
                onAfterChange={onAfterChange}
              />
            </ConfigProvider>
          </div>
        </div>
      </Card>
      {scanResultHtml(scanTableList, true)}
      <div
        style={{
          padding: '16px 0',
          fontSize: '1rem'
        }}
        className="displayFlex justifyContentSB tagTypeVal"
      >
        <span>{formatMessageNew(`languageObj.greyMarketLocale.scanRecord`)}</span>
        <span>
          {formatMessageNew('languageObj.commonLocale.total')}:{' '}
          <span style={{ color: '#1677ff', padding: '0 5px' }}>{tableList.length}</span>
          {formatMessageNew(`languageObj.greyMarketLocale.results`)}
        </span>
      </div>
      <Card size="small">
        <AntdTable
          rowClassName={(record, idx) => rowClassNameFun(record, idx)}
          onRow={(record, idx) => {
            return {
              onClick: () => {
                clickTableRow(record, idx)
              }
            }
          }}
          dataSource={tableList}
          columns={tableColumns}
          pagination={false}
        />
      </Card>
      <Modal
        open={visibleFlag}
        maskClosable={false}
        className="nike_modal"
        title={formatMessageNew('languageObj.greyMarketLocale.scanResult')}
        onCancel={handleUserCancel}
        footer={null}
      >
        {scanResultHtml(checkItem)}
      </Modal>
    </div>
  )
}

export default GreyMarketScanRF
